/**
 * iter189 - Reusable SEO head block.
 *
 * Fixes the Bing warnings:
 *   - "Too many pages with identical titles"
 *   - "Too many pages with identical meta descriptions"
 *
 * Every marketing / product page mounts <SEOHead title="..." description="..." />
 * and gets its OWN unique <title>, meta description, og:title, og:description,
 * twitter:title, twitter:description, and canonical URL. Pages without an
 * override quietly inherit the site defaults from public/index.html.
 *
 * Usage:
 *   <SEOHead
 *     title="Free IEP Sample - 4 SMART Goals for Any Age or Condition | SpectraLearn"
 *     description="Generate a starter IEP with 4 SMART goals tuned to your student's age and diagnosis. Email + PDF. Free. Endrew F. + IDEA aligned."
 *     canonical="https://spectralearn.co/sample-iep"
 *   />
 */
import React from "react";
import { Helmet } from "react-helmet-async";

const DEFAULT_OG_IMAGE = "https://spectralearn.co/og-image.png?v=2";

export default function SEOHead({ title, description, canonical, ogImage, noindex = false }) {
  return (
    <Helmet>
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
      {canonical && <link rel="canonical" href={canonical} />}
      {title && <meta property="og:title" content={title} />}
      {description && <meta property="og:description" content={description} />}
      {canonical && <meta property="og:url" content={canonical} />}
      {title && <meta name="twitter:title" content={title} />}
      {description && <meta name="twitter:description" content={description} />}
      <meta property="og:image" content={ogImage || DEFAULT_OG_IMAGE} />
      <meta name="twitter:image" content={ogImage || DEFAULT_OG_IMAGE} />
      {noindex && <meta name="robots" content="noindex,follow" />}
    </Helmet>
  );
}
